const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.grid-product',
};

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(function() {    
  initButtons();
  initGrid(); 
  },3000);
setTimeout(function() {      
   initButtonsonWishlist()
  },4000); 
});

document.addEventListener('shopify-wishlist:updated', (event) => {
  console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
  initGrid();
});

document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
  console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);
});

document.addEventListener('shopify-wishlist:init-buttons', (event) => {
  console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
    return productCard.outerHTML;
  })
  .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML); 
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join('');
  if(requests.length > 0)
  grid.innerHTML = wishlistProductCards;
  else
  grid.innerHTML = "<h3 style='text-align: center; margin-top: 5rem;color:#7a3331'>No Product found in Wishlist</h3>";  
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: wishlist }
  });
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    if(!button.classList.contains('click-event-added')) {
      const productHandle = button.dataset.productHandle || false;
      if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
      if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
      button.addEventListener('click', (e) => {
        updateWishlist(productHandle);
        button.classList.toggle(BUTTON_ACTIVE_CLASS);
      });
      button.classList.add('click-event-added')
    }
    
  });
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist){ 
    document.querySelector(".site-nav__link--icon--wishlist > span").innerText  = wishlist.split(LOCAL_STORAGE_DELIMITER).length;
    document.querySelector(".site-nav__link--icon--wishlist > span").style.display  = "flex";
    return wishlist.split(LOCAL_STORAGE_DELIMITER);
  }else{
    document.querySelector(".site-nav__link--icon--wishlist > span").innerText  = 0;
    document.querySelector(".site-nav__link--icon--wishlist > span").style.display  = "none";
  }
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);
getWishlist();
  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  const isAdding = indexInWishlist === -1;
  
  if (isAdding) {
    wishlist.push(handle);
    sendGA4WishlistEvent(handle);
  } else {
    wishlist.splice(indexInWishlist, 1);
  }
  
  return setWishlist(wishlist);
};

const sendGA4WishlistEvent = (handle) => {
  try {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'add_to_wishlist',  {
          send_to: 'G-CZYSDYJ076',
          item_id: handle,
          item_name: handle,
      });
    }
      if (typeof fbq === 'function') {
          fbq('track', 'AddToWishlist', {
              content_ids: [handle],
              content_name: handle,
              content_type: 'product',
          });

      }
  } catch (error) {
    console.error('Error sending GA4 event:', error);
  }
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};
function initButtonsonWishlist(){ 
  $("body").on("click",".grid-product__link,.st-ProductItem__ImageWrapper",function(event){
    if(event.target.tagName.toLowerCase() == "button" || event.target.tagName.toLowerCase() == "path" || event.target.tagName.toLowerCase() == "svg"){
              event.preventDefault();
   }
  }) 
}